import React from 'react';

export interface RelatedContentTitleProps {
  title: string;
  className?: string;
}

const RelatedContentTitle: React.FC<RelatedContentTitleProps> = (props) => {
  const { title, className } = props;

  return (
    <h2 className={className}>{title}</h2>
  );
};

export default RelatedContentTitle;
